import { useState } from "react";

interface IHWindow {
  Hubspot: any;
}

const useHubspot = () => {
  const [hubspotScript, setHubspotScript] = useState<any>();

  const destroyHubspotForm = () => {
    //@ts-ignore
    window.Hubspot = undefined;
    if (hubspotScript) {
      $("#hubspot-messages-iframe-container").remove();
      
      try {
        document.head.removeChild(hubspotScript);
      }
      catch(error) {
        console.warn(error);
      }
    }
  };

  const getHubspotForm = () => {
    destroyHubspotForm();
    //@ts-ignore
    const hWindow = window as IHWindow;
    hWindow.Hubspot = {};
    var script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = "//js.hs-scripts.com/6892734.js";
    document.head.appendChild(script);
    setHubspotScript(script);
  };

  return {
    getHubspotForm,
    destroyHubspotForm
  };
};

export default useHubspot;
